<div id="{{ contentId }}" class="se-menu" [ngClass]="menuClass">
  <div class="se-menu-wrapper" [ngStyle]="maxHeightStyle" [ngClass]="{'se-menu__scrollbar': !!maxHeightStyle}">

    <div
      class="se-menu-section"
      *ngFor="let section of options.sections"
      [ngClass]="{'se-menu__divider': section.divider === true }">

      <div *ngIf="section.header" class="se-menu-section__header" [attr.aria-label]="'section.header'">
        {{ section.header }}
      </div>

      <div *ngFor="let item of section.menuItems">
        <button
          *ngIf="item.action"
          type="button"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          (click)="item.action()"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </button>

        <a
          *ngIf="item.href"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          [attr.href]="item.href"
          [attr.target]="item.target"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </a>

        <a
          *ngIf="item.uiSref"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          [attr.routerLink]="item.uiSref"
          [attr.target]="item.target"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </a>

        <a
          *ngIf="item.gotoContext"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          [attr.goto-context]="item.href"
          [attr.target]="item.target"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </a>

        <a
          *ngIf="item.routerLink"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          [routerLink]="item.routerLink"
          [attr.target]="item.target"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </a>

        <button
          *ngIf="!item.action && !item.href && !item.uiSref && !item.gotoContext && !item.routerLink"
          type="button"
          class="se-menu-item"
          [ngClass]="getItemClass(item, section)"
          [attr.aria-label]="item.text">
          <se-menu-item [se-data-menu-item]="item"></se-menu-item>
        </button>

      </div>

    </div>
  </div>
</div>
